import React from 'react';
import styles from './StatsCard.module.css';
import StatsInProgressModal from "./StatsInProgressModal";
import {modalClose, modalOpen} from "../../store/modalSlice";
import {useDispatch} from "react-redux";
import {setDocToView} from "../../store/navSlice";

const StatsCard = ({primaryQueue, qaQueue, finished}) => {
    const dispatch = useDispatch()

    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [list, setList] = React.useState([])
    const [title, setTitle] = React.useState("")

    const closeModal = () => {
        dispatch(modalClose())
        setIsModalOpen(false);
        setList([])
        setTitle("")
    }

    const openPR = () => {
        dispatch(modalOpen())
        setIsModalOpen(true)
        setList(primaryQueue)
        setTitle("Primary Queue")
    }

    const openQA = () => {
        dispatch(modalOpen())
        setIsModalOpen(true)
        setList(qaQueue)
        setTitle("QA Queue")
    }

    const goToDocument = (doc) => {
        dispatch(setDocToView(doc))
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.lineItem}>
                {
                    primaryQueue.length > 0
                        ?
                        <>
                            <button onClick={openPR} className={styles.queueTitleButton}>
                                In PR Queue
                            </button>
                            <p className={styles.queueTitleColon}>:</p>
                        </>
                        :
                        <>
                            <p className={styles.queueTitleText}>In PR Queue: </p>
                            <p className={styles.queueTitleColon}>:</p>
                        </>
                }
                <p className={styles.queueValue}>{primaryQueue.length}</p>
            </div>
            <div className={styles.lineItem}>
                {
                    qaQueue.length > 0
                        ?
                        <>
                            <button onClick={openQA} className={styles.queueTitleButton}>
                                In QA Queue
                            </button>
                            <p className={styles.queueTitleColon}>:</p>
                        </>
                        :
                        <>
                            <p className={styles.queueTitleText}>In QA Queue: </p>
                            <p className={styles.queueTitleColon}>:</p>
                        </>
                }
                <p className={styles.queueValue}>{qaQueue.length}</p>
            </div>
            <div className={styles.lineItem}>
                <p className={styles.queueTitleText}>Finished Review</p>
                <p className={styles.queueTitleColon}>:</p>
                <p className={styles.queueValue}>{finished}</p>
            </div>
            <StatsInProgressModal open={isModalOpen} closeModal={closeModal} list={list} title={title}
                                  selectDoc={goToDocument}/>
        </div>
    );
};

export default StatsCard;